import { lazy } from "react";
import { hasQueryParam } from "common/helpers";

import NotificationsActiveIcon from "@material-ui/icons/NotificationsActive";
import SignalCellularAltIcon from "@material-ui/icons/SignalCellularAlt";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import NetworkCheckIcon from "@material-ui/icons/NetworkCheck";
import DescriptionIcon from "@material-ui/icons/Description";
import AssessmentIcon from "@material-ui/icons/Assessment";
import AssignmentIcon from "@material-ui/icons/Assignment";
import TableChartIcon from "@material-ui/icons/TableChart";
import DashboardIcon from "@material-ui/icons/Dashboard";
import ApartmentIcon from "@material-ui/icons/Apartment";
import EqualizerIcon from "@material-ui/icons/Equalizer";
import DeviceHubIcon from "@material-ui/icons/DeviceHub";
import SwapHorizIcon from "@material-ui/icons/SwapHoriz";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import BusinessIcon from "@material-ui/icons/Business";
import TimelineIcon from "@material-ui/icons/Timeline";
import SettingsIcon from "@material-ui/icons/Settings";
import HealingIcon from "@material-ui/icons/Healing";
import DevicesIcon from "@material-ui/icons/Devices";
import ReceiptIcon from "@material-ui/icons/Receipt";
import PersonIcon from "@material-ui/icons/Person";
import PeopleIcon from "@material-ui/icons/People";
import DomainIcon from "@material-ui/icons/Domain";
import PublicIcon from "@material-ui/icons/Public";
import InfoIcon from "@material-ui/icons/Info";
import MapIcon from "@material-ui/icons/Map";

const MonitorDashboard = lazy(() => import("views/MonitorDashboard/MonitorDashboard.js"));
const SignalIntegrityDashboard = lazy(() => import("views/SignalIntegrity/MonitorDashboard.js"));
const AddDevice = lazy(() => import("views/AddDevice/AddDevice.js"));
const PatientDevice = lazy(() => import("views/PatientDevice/PatientDevice.js"));
const Manufacturer = lazy(() => import("views/Manufacturer/Manufacturer.js"));
const ResidentMap = lazy(() => import("views/ResidentMap/ResidentMap.js"));
const DeviceTable = lazy(() => import("views/DeviceTable/DeviceTable.js"));
const DevHealthData = lazy(() => import("views/DevHealthData"));
const DeviceHealth = lazy(() => import("views/DeviceHealth/DeviceHealth"));
const DeviceManagement = lazy(() => import("views/DeviceManagement"));
const AuditLogs = lazy(() => import("views/AuditLogs/AuditLogs.js"));
const DiagnosticPanel = lazy(() => import("views/DiagnosticPanel"));
const DeviceSettings = lazy(() => import("views/DeviceSettings"));
const Insights = lazy(() => import("views/Insights/Insights.js"));
const Patient = lazy(() => import("views/Patient/Patient.js"));
const Company = lazy(() => import("views/Company/Company.js"));
const Devices = lazy(() => import("views/Devices/Devices.js"));
const Observe = lazy(() => import("views/Observe/Observe.js"));
const Users = lazy(() => import("views/Users/Users.js"));
const ErrorLogs = lazy(() => import("views/ErrorLogs"));
const AlertLogs = lazy(() => import("views/AlertLogs"));
const GuestMap = lazy(() => import("views/GuestMap"));
const Facility = lazy(() => import("views/Facility"));
const Invites = lazy(() => import("views/Invites"));
const Reports = lazy(() => import("views/Reports"));
const DeviceBilling = lazy(() => import("views/DeviceBilling"));
const Configuration = lazy(() => import("views/Configuration"));

var dashRoutes = [
  {
    path: "/dashboard",
    name: "Monitor Dashboard",
    roles: [
      "TenantAdmin",
      "TenantUser",
      "PracticeAdmin",
      "SupplierAdmin",
      "SupplierUser",
      "PracticeUser",
      "Patient",
      "Guest"
    ],
    icon: DashboardIcon,
    component: MonitorDashboard,
    layout: "/admin",
  },
  {
    path: "/signal-integrity",
    name: "Signal Integrity",
    roles: ["TenantAdmin", "TenantUser"],
    icon: SignalCellularAltIcon,
    component: SignalIntegrityDashboard,
    layout: "/admin",
  },
  /* {
    path: "/register-device",
    name: "Add Device",
    roles: ["TenantAdmin", "TenantUser"],
    icon: RouterIcon,
    component: AddDevice,
    layout: "/admin",
  }, */
  {
    path: "/table",
    name: "Device Data",
    roles: ["TenantAdmin"],
    icon: TableChartIcon,
    component: DeviceTable,
    layout: "/admin",
  },
  {
    path: "/devhealth-data",
    name: "DevHealth Data",
    roles: ["TenantAdmin"],
    icon: HealingIcon,
    component: DevHealthData,
    layout: "/admin",
  },
  {
    name: "Device Table",
    roles: ["TenantAdmin"],
    icon: DevicesIcon,
    path: "/device",
    component: Devices,
    layout: "/admin",
  },
  {
    path: "/manufacturer",
    name: "Manufacturer",
    roles: ["TenantAdmin", "TenantUser"],
    icon: DomainIcon,
    component: Manufacturer,
    layout: "/admin",
  },
  {
    path: "/company",
    name: "Company",
    roles: ["TenantAdmin", "TenantUser", "SupplierAdmin"],
    icon: BusinessIcon,
    layout: "/admin",
    component: Company,
  },
  {
    path: "/facility",
    name: "Facility",
    roles: ["TenantAdmin", "TenantUser", "SupplierAdmin", "SupplierUser", "PracticeAdmin"],
    icon: ApartmentIcon,
    layout: "/admin",
    component: Facility,
  },
  {
    path: "/resident",
    name: "Care Team",
    roles: ["TenantAdmin", "TenantUser", "SupplierAdmin", "SupplierUser", "PracticeUser", "PracticeAdmin"],
    icon: PeopleIcon,
    component: Patient,
    layout: "/admin",
  },
  {
    path: "/user",
    name: "User",
    roles: ["TenantAdmin", "TenantUser", "SupplierAdmin", "SupplierUser", "PracticeAdmin", "PracticeUser"],
    icon: PersonIcon,
    component: Users,
    layout: "/admin",
  },
  {
    path: "/map-resident",
    roles: ["TenantAdmin", "TenantUser"],
    name: "Resident Map",
    icon: MapIcon,
    component: ResidentMap,
    layout: "/admin",
  },
  {
    path: "/audit-logs",
    name: "Audit Logs",
    roles: ["TenantAdmin"],
    icon: AssignmentIcon,
    component: AuditLogs,
    layout: "/admin",
  },
  {
    path: "/error-logs",
    name: "Error Logs",
    roles: ["TenantAdmin"],
    icon: ErrorOutlineIcon,
    component: ErrorLogs,
    layout: "/admin",
  },
  {
    path: "/observe",
    name: "Users",
    roles: [
      "Patient",
      "Guest"
    ],
    icon: PeopleIcon,
    component: Observe,
    layout: "/admin",
  },
  {
    path: "/alert-logs",
    name: "Alert Logs",
    roles: ["TenantAdmin", "Patient",  "Guest", "PracticeUser", "PracticeAdmin", "SupplierAdmin", "SupplierUser", "Patient"],
    icon: NotificationsActiveIcon,
    component: AlertLogs,
    layout: "/admin",
  },
  {
    path: "/diagnostic-panel",
    name: "Diagnostic Panel",
    roles: ["TenantAdmin"],
    icon: TimelineIcon,
    component: DiagnosticPanel,
    layout: "/admin",
  },
  {
    path: "/guest-map",
    name: "Guest Map",
    roles: ["TenantAdmin"],
    icon: PublicIcon,
    component: GuestMap,
    layout: "/admin",
  },
  {
    path: "/invites",
    name: "Invites",
    roles: ["Guest"],
    icon: PersonAddIcon,
    component: Invites,
    layout: "/admin",
  },
  {
    path: "/device-billing",
    name: "Device Billing",
    roles: ["TenantAdmin"],
    icon: ReceiptIcon,
    component: DeviceBilling,
    layout: "/admin",
  },
  {
    path: "/configuration",
    name: "Device Information",
    roles: [
      "TenantAdmin",
      "TenantUser"
    ],
    icon: InfoIcon,
    component: Configuration,
    layout: "/admin",
  },
  {
    path: "/settings",
    name: "Device Settings",
    roles: ["TenantAdmin", "TenantUser", "SupplierAdmin", "SupplierUser", "PracticeAdmin", "PracticeUser", "Patient"],
    icon: SettingsIcon,
    component: DeviceSettings,
    layout: "/admin",
  },
  {
    path: "/management",
    name: "Device Migration",
    roles: ["TenantAdmin"],
    icon: SwapHorizIcon,
    component: DeviceManagement,
    layout: "/admin",
  },
  {
    path: "/reports",
    name: "Reports",
    roles: ["TenantAdmin", "TenantUser"],
    icon: DescriptionIcon,
    component: Reports,
    layout: "/admin",
  },
  {
    collapse: true,
    name: "Analytics",
    icon: AssessmentIcon,
    state: "analyticsCollapse",
    roles: [
      "TenantAdmin",
      "TenantUser",
      "SupplierAdmin",
      "SupplierUser",
      "PracticeAdmin",
      "PracticeUser",
      "Patient",
    ],
    views: [
      {
        path: "/insights",
        name: "Insights",
        mini: "IN",
        roles: [
          "TenantAdmin",
          "TenantUser",
          "SupplierAdmin",
          "SupplierUser",
          "PracticeAdmin",
          "PracticeUser",
          "Patient",
        ],
        icon: EqualizerIcon,
        component: Insights,
        layout: "/admin",
      },
      {
        path: "/device-health",
        name: "Device Health",
        mini: "DH",
        roles: ["TenantAdmin", "TenantUser", "SupplierAdmin", "SupplierUser"],
        icon: NetworkCheckIcon,
        component: DeviceHealth,
        layout: "/admin",
      },
    ],
  },
  {
    path: "/patient-device",
    name: "Patient Device",
    roles: ["TenantAdmin", "TenantUser"],
    icon: DeviceHubIcon,
    component: PatientDevice,
    layout: "/admin",
  },
];

if (hasQueryParam('showreport')) {
  dashRoutes.splice(dashRoutes.length - 2, 0, {
    path: "/reports",
    name: "Reports",
    roles: ["TenantAdmin", "TenantUser", "SupplierAdmin", "SupplierUser", "PracticeAdmin", "PracticeUser", "Patient"],
    icon: DescriptionIcon,
    component: Reports,
    layout: "/admin",
  });
}

export default dashRoutes;
